<style>
  .children-module-content {
    /* background: transparent !important; */
    padding: 25px !important;
  }
</style>
<template>

  <div class="children-container">
    <div class="children-module-name">鼠币订单</div>
    <div class="children-module-info">
      <a-table :columns="columns" bordered :data-source="list" rowKey="id" :pagination="false">
        <template slot="good_json" slot-scope="text, record">
          {{record.good_json.title}}
        </template>
        <template slot="state" slot-scope="text, record">
          <span v-if="text == 'TOBEDELIVERED'">待发货</span>
          <span v-if="text == 'SHIPPED'">已发货，待确认收货</span>
          <span v-if="text == 'OVER'">订单完成</span>
        </template>
        <template slot="expandedRowRender" slot-scope="record">
          <div style="display: flex">
            <div class="list" style="margin-right: 10px">
              <div class="title">商品信息</div>
              <div class="item"><span class="label">商品名称: </span><span class="content">{{ record.good_json.title }}</span>
              </div>
              <div class="item"><span class="label">兑换鼠币: </span><span class="content">{{ record.good_json.price }}</span>
              </div>
              <div class="item"><span class="label">兑换时间: </span><span class="content">{{ record.create_time }}</span></div>
            </div>

            <div class="list" style="margin-left: 10px">
              <div class="title">用户信息</div>
              <div class="item"><span class="label">姓名: </span><span class="content">{{ record.name }}</span></div>
              <div class="item"><span class="label">手机号: </span><span class="content">{{ record.mobile }}</span></div>
              <div class="item"><span class="label">收货地址: </span><span
                  class="content">({{ record.address_json.name }}{{ record.address_json.mobile }}){{
                  record.province
                }}{{ record.city }}{{ record.area }}{{ record.address_json.info }}</span>
              </div>
            </div>
          </div>

          <div class="list">
            <div class="title">物流信息</div>
            <div class="item"><span class="label">物流名称: </span><span class="content">{{ record.logistics_code }}</span>
            </div>
            <div class="item"><span class="label">物流编号: </span><span class="content">{{ record.logistics_company }}</span>
            </div>
            <div class="item" v-if="record.logistics_json != null">
              <div v-for="(item, index) in record.logistics_json"><span style="margin-right: 10px">{{item.info}}</span><span>{{item.date}}</span></div>
            </div>
            <div v-if="record.state == 'SHIPPED'" style="padding-top: 10px">
              <span style="margin-left: 10px;cursor: pointer;color: #008276;" @click="openReceiving(record)">
                <a-icon type="edit"  style="margin-right: 10px;color: #008276"/><span>确认收货</span>
              </span>
            </div>
          </div>
        </template>
      </a-table>
      <div class="page-container">
        <a-pagination :hideOnSinglePage="true" :page-size.sync="page.pageSize" :total="page.totalRow"
          v-model="page.start" @change="changePage" />
      </div>
    </div>
  </div>
</template>

<script>
  import * as Api from './api';
  import * as commonApi from '@/commonApi';

  export default {
    data() {
      return {
        modalVisible: false,
        page: {
          start: 1,
          limit: 20,
          pageSize: 0,
          totalRow: 0,
        },
        list: [],
        columns: [
          {
            title: "商品名称",
            dataIndex: "good_json",
            scopedSlots: { customRender: "good_json" },
          },
          {
            title: "状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" },
            width: 150
          },
          {
            title: "创建时间",
            dataIndex: "create_time",
            scopedSlots: { customRender: "create_time" },
            width: 200
          },

        ]
      };
    },
    mounted() {
      this.getPage();
    },
    methods: {

      // 获取列表
      async getPage() {
        let res = await Api.GetPage(this.page);
        if (res && res["code"] == "0") {
          res.page.list.forEach(item => {
            item['good_json'] = JSON.parse(item['good_json'])
            item['address_json'] = JSON.parse(item['address_json'])
            if (item['logistics_json'] != null) {
              item['logistics_json'] = JSON.parse(item['logistics_json'])
            }
          })
          this.list = res.page.list;
          this.page.totalRow = res.page.totalRow;
          this.page.pageSize = res.page.pageSize;
        }
      },

      // 切换分页
      changePage(e) {
        this.page.start = e;
        this.getPage();
      },

      // 打开确认收货
      async openReceiving(record) {
        let that = this;
        this.$confirm({
          title: '信息提示',
          content: '您确定要收货吗?',
          async onOk() {
            let res = await Api.Confirm({id: record.id});
            if (res && res["code"] == "0") {
              that.$message.success('收货成功');
              that.getPage();
            }
          },
          onCancel() {},
        });
      },
    },
  };
</script>

<style lang="less">
  .tips-text {
    font-size: 14px;
    font-weight: 500;
    color: #007F76;
    line-height: 38px;
    padding-top: 2px;
  }

  .code {
    background-color: #007F76;
    font-size: 12px;
    color: #fff;
    font-weight: 500;
  }
</style>
<style>
.list {
  border: 1px solid #f5f5f5;
  margin-bottom: 20px;
  padding: 10px;
  text-align: left;
  flex: 1;
}

.list .title {
  font-weight: bold;
  line-height: 36px;
  border-bottom: 1px solid #eeeeee;
}

.list .item {
  line-height: 32px;
  border-bottom: 1px solid #eeeeee;
}

.list .item:last-child {
  border-bottom: none;
}
</style>
